import { MDBCol, MDBContainer, MDBIcon, MDBRow } from "mdbreact";
import { useEffect, useRef, useState } from "react";
import DataTable from "../../../components/DataTable/DataTable";
import PaidForm from "../../../components/Forms/PaidForm";
import Loading from "../../../components/Loading";
import axiosGet from "../../../helpers/axiosGet";
import ReactPaginate from "react-paginate";

const createInvoiceUrl = (page, values) => {
  const params = new URLSearchParams({
    insured: values?.insured || "",
    companyName: values?.companyName || "",
    invoiceNumber: values?.invoiceNumber || "",
    placingSlipNo: values?.placingSlipNo || "",
    productCode: values?.productCode || "",
    minSumInsured: values?.minSumInsured || "",
    maxSumInsured: values?.maxSumInsured || "",
    minPremium: values?.minPremium || "",
    maxPremium: values?.maxPremium || "",
    minPolicyIssueDate: values?.minPolicyIssueDate || "",
    maxPolicyIssueDate: values?.maxPolicyIssueDate || "",
    minInvoiceIssueDate: values?.minInvoiceIssueDate || "",
    maxInvoiceIssueDate: values?.maxInvoiceIssueDate || "",
    minSchedulePaymentDate: values?.minSchedulePaymentDate || "",
    maxSchedulePaymentDate: values?.maxSchedulePaymentDate || "",
    minPaymentDate: values?.minPaymentDate || "",
    maxPaymentDate: values?.maxPaymentDate || "",
    certificateNumber: values?.certificateNumber || "",
    status: "100",
    maxCount: "",
  });
  return `/invoice/page/${page}?${params.toString()}`;
};

const headers = [
  {
    label: (
      <>
        <div>Invoice Number</div>
        <div>Placing Slip Number</div>
        <div>Policy Number</div>
        <div>Reference Number</div>
      </>
    ),
    style: { minWidth: 210 },
  },
  { label: "Product Code" },
  {
    label: (
      <>
        Company Name <br />
        Insured <br />
        Insurer
      </>
    ),
    style: { minWidth: 250 },
  },
  {
    label: (
      <>
        Policy Issue Date <br />
        Invoice Issue Date <br />
        Schedule Payment Date <br />
        Payment Date
      </>
    ),
    style: { minWidth: 210 },
  },
  {
    label: (
      <>
        Sum Insured <br />
        Premium
      </>
    ),
    style: { minWidth: 140 },
  },
  { label: "Action" },
];

export default function PaidInvoice({ navigation }) {
  const scroll = useRef(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [invoices, setInvoices] = useState([]);
  const [values, setValues] = useState(null);
  const [page, setPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);

  const fetchInvoices = (nextPage = 1, nextValues = values) => {
    setLoading(true);
    axiosGet({
      url: createInvoiceUrl(nextPage, nextValues),
      callback: (res) => {
        setInvoices(res.data.data);
        setPage(res.data.page - 1);
        setTotalPage(res.data.totalPage);
        setLoading(false);
      },
      errorCallback: (err) => {
        console.log(err);
        setLoading(false);
      },
    });
  };

  useEffect(() => {
    fetchInvoices();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSearch = (searchValues) => {
    setValues(searchValues);
    fetchInvoices(1, searchValues);
  };
  const handleReset = () => {
    setValues(null);
    fetchInvoices(1, null);
  };
  const handlePageChange = ({ selected }) => {
    fetchInvoices(selected + 1);
    scroll.current?.scrollIntoView();
  };

  return (
    <>
      <div className="border rounded mt-5">
        <MDBContainer
          className="px-4 py-2"
          onClick={() => setOpen(!open)}
          style={{ cursor: "pointer" }}
        >
          <MDBRow>
            <MDBCol size="6" middle>
              <p className="mb-0">Search</p>
            </MDBCol>
            <MDBCol size="6" className="text-right">
              <MDBIcon icon={open ? "angle-up" : "angle-down"} size="lg" />
            </MDBCol>
          </MDBRow>
        </MDBContainer>
        {open && <PaidForm onSearch={handleSearch} onReset={handleReset} />}
      </div>

      {navigation}

      <div className="mt-5" ref={scroll}>
        {loading ? (
          <Loading />
        ) : (
          <>
            <div className="p-4 border rounded text-grey">
              <DataTable invoices={invoices} active="paid" headers={headers} />
              {!invoices.length && (
                <div className="font-weight-bold text-center">NO DATA</div>
              )}
            </div>
            {invoices.length > 0 && (
              <div className="mt-5 d-flex justify-content-end">
                {totalPage > 1 && (
                  <ReactPaginate
                    previousLabel={<MDBIcon icon="chevron-left" />}
                    nextLabel={<MDBIcon icon="chevron-right" />}
                    breakLabel="..."
                    pageCount={totalPage}
                    pageRangeDisplayed={2}
                    marginPagesDisplayed={1}
                    forcePage={page}
                    onPageChange={handlePageChange}
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    activeClassName="active"
                  />
                )}
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}
